// extracted by mini-css-extract-plugin
export var container = "info-traffic-le-pilote-module--container--bd619";
export var descriptionContainer = "info-traffic-le-pilote-module--descriptionContainer--271c0";
export var line = "info-traffic-le-pilote-module--line--d25ff";
export var lineDivider = "info-traffic-le-pilote-module--lineDivider--c32c6";
export var pictoBoxTop = "info-traffic-le-pilote-module--pictoBoxTop--a966e";
export var title = "info-traffic-le-pilote-module--title--020b0";
export var trafficContainer = "info-traffic-le-pilote-module--trafficContainer--ebaf1";